module.exports = __webpack_public_path__ + "static/media/amusement(17).6b687524.PNG";